import { Route, Routes } from "react-router-dom";
import {
    MainInterface,
    type MainInterfaceProps,
} from "@components/mainInterface/MainInterface";
import { PersonalSideNav } from "@components/navigation/sideNav/PersonalSideNav";
import { WorkspacesPage } from "@components/personalView/Workspaces/WorkspacesPage";
import { PersonalViewUserDropdownItems } from "@components/personalView/PersonalViewUserDropdownItems";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";
import { useRenderCommonRoutes } from "./useRenderCommonRoutes";
import { useRenderOrganizationRedirectRoutes } from "./useRenderOrganizationRedirectRoutes";

const PERSONAL_NAVIGATION = {
    sideNavigation: <PersonalSideNav />,
} satisfies Pick<MainInterfaceProps, "sideNavigation">;

export const PersonalViewRoutes = () => {
    const commonRoutes = useRenderCommonRoutes();
    const organizationRedirectRoutes = useRenderOrganizationRedirectRoutes();
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <MainInterface
                        {...PERSONAL_NAVIGATION}
                        dropdownItems={<PersonalViewUserDropdownItems />}
                        breadcrumbs={[{ label: "Workspaces" }]}
                    >
                        <WorkspacesPage />
                    </MainInterface>
                }
            />
            {commonRoutes}
            {organizationRedirectRoutes}

            <Route path="*" element={<StateAwareNavigate to="/" replace />} />
        </Routes>
    );
};
